module.exports = __webpack_public_path__ + "a2229049c40952cf1a4378e71a8b9cc4.svg";